import { render, staticRenderFns } from "./SwappTasks.vue?vue&type=template&id=3f2d5f63&scoped=true&"
import script from "./SwappTasks.vue?vue&type=script&lang=js&"
export * from "./SwappTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2d5f63",
  null
  
)

export default component.exports